import ByCounterReportsVue from '@/views/sic/by-counter-reports/by-counter-reports.vue';

const basePath = '/sic/by-counter-reports';
const role = 'sic'; // 角色身份

export const SIC_BY_COUNTER_REPORTS_INDEX = 'sic-by-counter-reports-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ByCounterReportsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_BY_COUNTER_REPORTS_INDEX,
      component: () => import(
        /* webpackChunkName: "reports" */
        `@/views/${role}/by-counter-reports/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
